var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74199 11.6969L14.9017 2.64532C15.2691 2.28229 15.8812 2.65616 15.7169 3.14322L13.4542 9.85142C13.277 10.3766 13.6725 10.9188 14.2326 10.9188H17.6778C18.4088 10.9188 18.775 11.7923 18.258 12.303L9.09828 21.3547C8.73091 21.7177 8.11876 21.3438 8.28306 20.8568L10.5459 14.1486C10.723 13.6234 10.3275 13.0812 9.76737 13.0812H6.32223C5.59117 13.0812 5.22504 12.2077 5.74199 11.6969Z",
    stroke: "#4C596E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.e60c1989d688270df2afd8128a84545d.svg";
export { ForwardRef as ReactComponent };